module.exports = __webpack_public_path__ + "img/exoskeleton-equipment.2ef75642.png";